
import { defineComponent } from 'vue';
import { useI18n } from '@/services/i18n';

export default defineComponent({
  name: 'Troubleshooting',

  setup() {
    return {
      t: useI18n().t
    };
  }
});
